import { useWatch } from "react-hook-form";

const defaultValidate = (value) => !!value;

export default function usePartialFormValidation(name, validate = defaultValidate) {
	const values = useWatch({ name });

	return Object.values(values).every(validate);
}
